import styled, { css } from 'styled-components'
import { Container } from 'src/components/common/Container'
import { CustomSwiper } from 'src/components/common/CustomSwiper'
import { MainPageProps } from 'src/pages/MainPage'
import { Noto_body3_r12 } from 'src/styles/fonts/NotoSansKrFonts'
import { useNavigate } from 'react-router-dom'

import usePageNav from 'src/hooks/usePageNav.hook'
import LazyImage from 'src/components/common/LazyImage'
import useDynamicWidth from 'src/hooks/useDynamicWidth.hook'

const MainTopBanner = ({ mainTopBannerList }: MainPageProps) => {
  const navigate = useNavigate()
  const { deviceWidth } = useDynamicWidth()
  const { addUtmParameter } = usePageNav()

  const replaceWindowOriginUrl = (url?: string) => {
    return addUtmParameter(
      `${url
        ?.replace('https://svc.couponwallet.co.kr', '')
        ?.replace('https://dev-svc.couponwallet.co.kr', '')
        ?.replace('http://localhost:3000', '')}`
        ?.replace('/web', '')
        ?.replace('/aos', '')
        ?.replace('/ios', ''),
    )
  }

  return (
    <S.MainTopBannerContainer $width="calc(100% - 40px)">
      <CustomSwiper.Wrap
        type="default"
        gap={20}
        $wrapstyle={S.MainTopBannerSwiperWrapStyle}
        swiperOption={{
          autoplay: { delay: 2500, disableOnInteraction: false },
          loop: true,
        }}
      >
        {mainTopBannerList?.map(({ URL, Image }, i: number) => (
          <CustomSwiper.Item $itemstyle={S.MainTopBannerSwiperItemsStyle} key={i}>
            <LazyImage
              src={Image}
              alt="배너 이미지"
              style={S.MainTopBannerImg(deviceWidth)}
              onClick={() => navigate(replaceWindowOriginUrl(URL))}
            />
          </CustomSwiper.Item>
        ))}
      </CustomSwiper.Wrap>
    </S.MainTopBannerContainer>
  )
}
export default MainTopBanner

const S = {
  MainTopBannerContainer: styled(Container)`
    padding: 20px 0 0 0;
    position: relative;
  `,
  MainTopBannerSwiperWrapStyle: css`
    border-radius: 20px;
    width: 100%;
    height: 160px;
    position: relative;
    .swiper-pagination {
      display: flex !important;
      width: fit-content;
      position: relative;
      top: -34px;
      margin-right: 10px;
      float: right;
      height: 24px;
      padding: 0 10px;
      border-radius: 50px;
      background: rgba(0, 0, 0, 0.5);
      ${Noto_body3_r12};
      color: var(--white);
      align-items: center;
    }
  `,
  MainTopBannerSwiperItemsStyle: css`
    width: 100%;
    height: 160px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 20px;
    column-gap: 16px;
    position: relative;
  `,
  MainTopBannerImg: (deviceWidth: number) => css`
    width: 100%;
    min-width: 280px;
    margin: 0 auto;
    height: 160px;
    max-height: 160px;
    border-radius: 20px;
    position: relative;
    img {
      width: 100%;
      object-fit: cover;
      object-position: center;
    }
    &:hover {
      transform: ${deviceWidth > 320 ? 'scale(1.05)' : 'unset'};
    }
  `,
}
